import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { ChunkWrapper, Feedback, useLlm } from '@websolutespa/bom-mixer-llm';
import React from 'react';
import { Disclaimer } from '../Disclaimer/disclaimer';
import style from './thread.module.scss';

export type ThreadProps = {
};

export const Thread: React.FC<ThreadProps> = () => {
  const label = useLabel();
  const {
    Stream,
  } = useLlm(state => state.components);
  const enableFeedback = useLlm(state => state.app?.contents.enableFeedback);
  const messages = useLlm(state => state.messages);
  const hasChunks = useLlm(state => state.chunks !== undefined);
  return (
    <section className={style.thread}>
      {messages.map((message, m) => (
        <div
          key={`llm-message-${m}`}
          className={getClassNames(
            style.threadMessage,
            message.role === 'user' ? style.threadMessageUser : style.threadMessageAssistant
          )}
          role="region"
          aria-label={message.role === 'user' ? label('llm.question') : label('llm.answer')}>
          {message.chunks.map((chunk, c) => (
            <ChunkWrapper
              key={`llm-message-${m}-chunk-${c}`}
              className={getClassNames(style.threadInner, style[chunk.type as string])}
              item={chunk} chunkIndex={c} index={m} total={messages.length} role={message.role}
            />
          ))}
          {message.role === 'user' ? (
            m === 0 && <Disclaimer />
          ) : (
            m === messages.length - 1 && enableFeedback && <Feedback message={message} />
          )}
        </div>
      ))}
      {hasChunks && (
        <Stream index={messages.length} />
      )}
    </section>
  );
};
